import { render, staticRenderFns } from "./OnSaleList.vue?vue&type=template&id=75b88f5a&scoped=true&"
import script from "./OnSaleList.vue?vue&type=script&lang=js&"
export * from "./OnSaleList.vue?vue&type=script&lang=js&"
import style0 from "./OnSaleList.vue?vue&type=style&index=0&id=75b88f5a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b88f5a",
  null
  
)

export default component.exports